<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M27.5 23.125V4.375H2.5V23.125H0V25.625H30V23.125H27.5ZM17.5 23.125H12.5V21.875H17.5V23.125ZM5 19.375H25V6.875H5V19.375Z" fill="#000"/>
</svg>
